export const environment = {
  isLocalDev: false,
  federationManifest: 'federation.manifest.uatr.json',
  idp: {
    issuer: 'https://api-services.uat.1placedessaisons.com/uatr/v1/oidc',
    clientId: 'd7e57fd4-8b42-4d96-93d4-ab7ff0285cff',
  },
  rmPermissionsCheckUrl: 'https://api-services.uat.1placedessaisons.com/uatr/v3/permissions/check',
  dataRefsBusinessUnitsUrl: 'https://api-services.uat.1placedessaisons.com/uatr/v1/businessUnits',
  requiredActionResourcesPermissions: {
    jade_admin: ['APP_JADE_MAIL_TO_TICKET'],
    'jade_api_mail-to-ticket_read_customer-service': [],
  },
};
